import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const PaymentPolicy = () => {
  return (
    <div style={{padding:24}}>
      <h1 className="page-title">Payment Policy</h1>
      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          Our Payment Policy explains how payments are processed on OneAI, what you can expect after completing a transaction, and how we handle receipts and disputes. We use a trusted third-party payment processor to ensure sensitive payment information is handled securely.
        </p>
        <p>
          This page covers processor responsibilities, receipts, refunds, and contact points for billing support. If you purchase a subscription or make a one-time payment, you will receive confirmation and a receipt by email.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Secure payment processing handled by a PCI-compliant provider.</li>
          <li>Receipts sent by email; contact our billing team for disputes.</li>
          <li>Refunds processed according to provider and platform policies.</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          We prioritize secure, transparent billing. Payment methods, recurring billing schedules, and any trial or promotional credits are clearly displayed during checkout. For subscription plans, you can update or cancel billing through your account settings; cancellation typically stops future billing but may not retroactively refund past usage unless otherwise stated in our Refund Policy. We do not store full card information — payment details are handled by the processor and tokens are used where necessary to support recurring billing.
        </p>
        <p>
          If you need an invoice for accounting purposes, contact billing with your account and order details and we will provide necessary documentation. For disputed charges, provide as much information as possible (transaction ID, date, and description) to speed up investigation and resolution.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Clear billing notifications and receipts for every purchase.</li>
          <li>Manage subscriptions from your account dashboard.</li>
          <li>Contact billing for invoices and dispute resolution.</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          Our team is available to answer billing questions and provide invoices on request. For businesses and teams requiring purchase orders or special invoicing, contact our sales or billing team to discuss options and setup. We document trial periods, promotional credits, and auto-renewal details so customers can make informed decisions.
        </p>

        <p>
          Keep an eye on billing notifications in your account and contact billing immediately if you notice unexpected activity. We strive to keep billing transparent and auditable to support accounting and compliance needs for individuals and organizations.
        </p>
      </div>

      <p>Last updated: {new Date().toISOString().split('T')[0]}</p>

      <p>OneAI uses Razorpay as our payment processor for subscription and donation payments. This page outlines what you can expect when paying on OneAI.</p>

      <h3>Payment processor</h3>
      <p>Payments are processed by Razorpay. We do not store full payment card details on our servers — Razorpay handles sensitive payment information. For more details, see Razorpay's docs: https://razorpay.com/docs/</p>

      <h3>Security</h3>
      <p>Razorpay is PCI-compliant. All payment transactions made through Razorpay use secure channels and industry-standard encryption.</p>

      <h3>Receipts and disputes</h3>
      <p>After payment, you will receive a receipt. For disputes, please contact info.onehubtech@gmail.com and we will help initiate any refund or dispute process with Razorpay.</p>

      <h3>Contact</h3>
      <p>Payments support: info.onehubtech@gmail.com</p>

      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentPolicy;
